import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { DataService } from '../../../../symphony';

import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';

import s from './LearningPathHeader.scss';

interface ILearningPathHeaderProps {
	alias: string;
}
export function LearningPathHeader({
	alias,
}: ILearningPathHeaderProps): JSX.Element {
	useStyles(s);
	const { learningExperiences$: learningExperiences } = useContainerData(
		'global',
		DataService,
		['learningExperiences$'],
	);

	if (!learningExperiences) {
		return null;
	}

	const {
		name,
		description,
		uiConfigurations: { iconUrl },
	} = learningExperiences.find((le) => le.alias === alias);

	return (
		<div className="learning-path-header-container">
			<div className="learning-path-header">
				<div className="learning-path-header__icon">
					<img src={iconUrl} alt={name} />
				</div>
				<div className="learning-path-header__content">
					<div className="learning-path-header__name">{name}</div>
					<div className="learning-path-header__description">
						{description}
					</div>
				</div>
			</div>
		</div>
	);
}
